export default "__VITE_ASSET__CWzwvXAy__"